/** 帮助中心 **/
const helpCenter = {
  namespaced: true,
  state: {
    // 任务状态 false 未完成，true 已完成
    newbieTaskStatus: {
      searchInfo: null,
      collectExport: null,
      companyMonitor: null,
      subscribeInfo: null,
      bindWechat: null,
    },
    isShowPopupNewbieTasks: false,
  },
  getters: {
    newbieTaskStatus: (state) => state.newbieTaskStatus,
    isShowPopupNewbieTasks: (state) => state.isShowPopupNewbieTasks,
  },
  mutations: {
    updateNewbieTaskStatus(state, newbieTaskStatus) {
      state.newbieTaskStatus = newbieTaskStatus;
    },
    updateIsShowPopupNewbieTasks(state, isShowPopupNewbieTasks) {
      state.isShowPopupNewbieTasks = isShowPopupNewbieTasks;
    },
  },
  actions: {},
};
export default helpCenter;
